import http from '@/utils/http';

const baseUrl = '/monitoramento/agricola';

export default {
    pesquisar(filtro) {
        return http.get({
            url: baseUrl + `/pesquisa-inteligente?filtro=${filtro}`,
            lockScreen: false
        });
    },

    buscarSafraFiltroAvancado() {
        return http.get({
            url: baseUrl + `/filtros-avancados/safras`,
            lockScreen: false
        });
    },

    buscarAreasMonitoradas(filtros, { pagina, tamanho, ordenacao }) {
        return http.post({
            url:
                baseUrl +
                `/areas-monitoradas?page=${pagina}&size=${tamanho}&sort=${ordenacao}`,
            data: filtros,
            lockScreen: false
        });
    },
    buscarTotalizadores(body) {
        return http.post({
            url: baseUrl + '/totalizador',
            data: body,
            lockScreen: false
        });
    },
    buscarTerritoriosNaoMonitorados(
        filtros,
        { pagina, ordenacao, tamanho = 20 }
    ) {
        return http.post({
            url:
                baseUrl +
                `/nao-monitorados?page=${pagina}&sort=${ordenacao}&size=${tamanho}`,
            data: JSON.parse(JSON.stringify(filtros)),
            lockScreen: false
        });
    },
    buscarAreaMonitoradaPorId(id) {
        return http.get({
            url: baseUrl + `/areas-monitoradas/${id}`,
            lockMessage: 'Buscando dados da área monitorada'
        });
    },

    buscarSituacaoAreaMonitoradaPorId(id) {
        return http.get({
            url: baseUrl + `/situacao/${id}`,
            lockMessage: 'Buscando situação da área monitorada'
        });
    },

    buscarAcuraciaMonitoramento(id, cultura) {
        return http.get({
            url: baseUrl + `/produtividade/acuracia/${id}/${cultura}`,
            lockMessage: 'Buscando acurácia da área monitorada'
        });
    },

    buscarAlertasPorAreaMonitoradaId(id) {
        return http.get({
            url: baseUrl + `/areas-monitoradas/${id}/alertas`,
            lockMessage: 'Buscando alertas da área monitorada'
        });
    },

    enviarAreasMonitoramento(body) {
        return http.post({
            url: baseUrl + `/salvar/area-monitoramento`,
            data: body,
            lockScreen: true,
            lockMessage: 'Enviando território para monitoramento'
        });
    },
    consultaRelatorio(body, { page, size, sort }) {
        return http.post({
            url:
                baseUrl +
                `/filtrar-relatorio?page=${page - 1}&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: true,
            lockMessage: 'Buscando dados de monitoramento'
        });
    },
    buscarRelatorioGrafico(body) {
        return http.post({
            url: baseUrl + `/grafico`,
            data: body,
            lockScreen: true,
            lockMessage: 'Buscando dados de monitoramento'
        });
    },
    async exportarRelatorio(body) {
        const fileLink = document.createElement('a');
        try {
            const response = await http.post({
                url: baseUrl + '/requisicao-xlsx',
                data: body,
                responseType: 'blob',
                lockScreen: true,
                lockMessage: 'Preparando dados para download'
            });
            if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                fileLink.href = fileURL;
                const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                const contentDisposition =
                    response.headers['content-disposition'];

                fileLink.setAttribute(
                    'download',
                    filenameRegex.exec(contentDisposition)[1]
                );
                document.body.appendChild(fileLink);

                fileLink.click();
                return Promise.resolve();
            }
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarResumoAlertasAgricolas(codigoAreaMonitorada) {
        let url;
        if (codigoAreaMonitorada) {
            url = `/alerta/resumo?codigoAreaMonitorada=${codigoAreaMonitorada}`;
        } else {
            url = `/alerta/resumo`;
        }

        return http.get({
            url: baseUrl + url,
            lockScreen: false
        });
    },

    buscarAlertaAgricola(body, { page, size }) {
        return http.post({
            url: baseUrl + `/alerta?pageIndex=${page - 1}&pageSize=${size}`,
            data: body,
            lockScreen: true,
            lockMessage: 'Buscando alertas'
        });
    },

    atualizaGraficoNdvi(codigoAreaMonitorada, codigosAcuracia) {
        return http.get({
            url:
                baseUrl +
                `/agro/${codigoAreaMonitorada}?codigosAcuracia=${codigosAcuracia}`,
            lockScreen: false
        });
    }
};
